module.exports = __webpack_public_path__ + "static/media/defend-msg.e85af7dc.svg";